import type { AdminUserDetailDto } from '@carcheck/shared';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Appeals tab of the user detail drawer (AUT-124). Reads `appealsFiled`
 * straight off the detail DTO — no extra fetch. The full appeals list is
 * an ADMIN-16 surface; here we surface the count the user filed.
 */
export const AppealsTab = ({ user }: { user: AdminUserDetailDto }): ReactElement => {
  const { t } = useTranslation();

  if (user.appealsFiled === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('users.detail.appealsTab.empty')}
      </Typography>
    );
  }

  return (
    <Typography variant="subtitle2">
      {t('users.detail.appealsTab.total', { count: user.appealsFiled })}
    </Typography>
  );
};
